import React from 'react';
import { NavLink } from 'react-router-dom';
import MaterialIcon from './MaterialIcon';

function NavBar() {
	return (
		<nav className="navBar">
			<ul className="nav__list">
				<li className="nav__listElement">
					<NavLink to="/" exact activeClassName="nav__listElement--active">
						<MaterialIcon>home</MaterialIcon>
					</NavLink>
				</li>
				<li className="nav__listElement">
					<NavLink to="/lists" activeClassName="nav__listElement--active">
						<MaterialIcon>list_alt</MaterialIcon>
					</NavLink>
				</li>
				<li className="nav__listElement">
					<NavLink to="/products" activeClassName="nav__listElement--active">
						<MaterialIcon>kitchen</MaterialIcon>
					</NavLink>
				</li>
			</ul>
		</nav>
	);
}

export default NavBar;
